// sai's StepTabs: the numbered steps of a product page, as tabs. Click, or
// arrow keys to move (Home and End to the ends). The panel they control is the
// page's stage.
//   trapeziumId(i) — the data-trapezium-id of step i's tab
export default function StepTabs({ steps, active, onChange, idBase, trapeziumId, label }) {
  const onKey = (e) => {
    const to = { ArrowRight: active + 1, ArrowLeft: active - 1, Home: 0, End: steps.length - 1 }[e.key];
    if (to === undefined) return;
    e.preventDefault();
    const next = (to + steps.length) % steps.length;
    onChange(next);
    document.getElementById(`${idBase}-tab-${next}`)?.focus();
  };

  return (
    <div className="prod-steps" role="tablist" aria-label={label} data-n={steps.length}>
      {steps.map((name, i) => (
        <button
          key={name}
          type="button"
          role="tab"
          id={`${idBase}-tab-${i}`}
          aria-selected={active === i}
          aria-controls={`${idBase}-panel`}
          tabIndex={active === i ? 0 : -1}
          data-trapezium-id={trapeziumId(i)}
          onClick={() => onChange(i)}
          onKeyDown={onKey}
        >
          <span className="n" aria-hidden="true">
            {String(i + 1).padStart(2, '0')}
          </span>
          <span className="t">{name}</span>
        </button>
      ))}
    </div>
  );
}
